/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {exchange} from '../api'

export const useMutationExchange = createReactQueryMutationHook('exchange', exchange)
